import React, { useEffect, useState } from 'react';
import {
    Container,
    Card,
    Table,
    Button,
    Modal,
    Form,
    Row,
    Col,
    Spinner,
    InputGroup
} from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus, FaSave, FaTimes, FaSearch } from 'react-icons/fa';
// import { db } from '../../services/firebaseConnection';
import { useFirebaseConnection } from '../../services/useFirebaseConnection';

import {
    collection,
    getDocs,
    setDoc,
    updateDoc,
    deleteDoc,
    doc
} from 'firebase/firestore';

export default function Planos() {
    const [planos, setPlanos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentPlano, setCurrentPlano] = useState(null);
    const [loading, setLoading] = useState(true);
    const { db } = useFirebaseConnection();

    const fetchPlanos = async () => {
        const snapshot = await getDocs(collection(db, 'planos'));
        const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setPlanos(list);
    };

    useEffect(() => {
        fetchPlanos().then(() => setLoading(false));
    }, []);

    const handleSave = async (planoData) => {
        try {
            // Normaliza o nome para usar como ID (opcional, mas recomendado)
            const normalizedId = planoData.nome.trim().toLowerCase().replace(/\s+/g, '_');

            if (planoData.id) {
                const planoRef = doc(db, 'planos', planoData.id);
                await updateDoc(planoRef, planoData);
            } else {
                const planoRef = doc(db, 'planos', normalizedId);
                await setDoc(planoRef, { ...planoData, id: normalizedId });
            }

            await fetchPlanos();
            setShowModal(false);
            setCurrentPlano(null);
        } catch (error) {
            console.error('Erro ao salvar plano:', error);
        }
    };

    const handleEdit = (plano) => {
        setCurrentPlano(plano);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Tem certeza que deseja excluir este plano?")) {
            await deleteDoc(doc(db, 'planos', id));
            await fetchPlanos();
        }
    };

    const handleNew = () => {
        setCurrentPlano(null);
        setShowModal(true);
    };

    return (
        <Container fluid className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1>Planos</h1>
                <Button variant="primary" onClick={handleNew} className="mb-3">
                    <FaPlus className="me-2" /> Novo Plano
                </Button>
            </div>
            
            {/* Barra de pesquisa */}
            <Card className="mb-4 shadow-sm">
                <Card.Body>
                <Row>
                    <Col>
                    <InputGroup>
                        <InputGroup.Text>
                        <FaSearch />
                        </InputGroup.Text>
                        <Form.Control
                        placeholder="Buscar por nome, CNPJ, email, endereço, bairro, cidade, estado ou CEP..."
                        // value={searchTerm}
                        // onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </InputGroup>
                    </Col>
                </Row>
                </Card.Body>
            </Card>

            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" />
                </div>
            ) : (
                <Card className="shadow-sm">
                    <Card.Body>
                        <div className="table-responsive">
                            <Table  hover>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Duração</th>
                                        <th>Unidade</th>
                                        <th>Valor (R$)</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {planos.map(plano => (
                                        <tr key={plano.id}>
                                            <td>{plano.nome}</td>
                                            <td>{plano.duracao}</td>
                                            <td>{plano.unidade}</td>
                                            <td>R$ {plano.valor}</td>
                                            <td>
                                                <Button
                                                    variant="warning"
                                                    size="sm"
                                                    onClick={() => handleEdit(plano)}
                                                    className="me-2"
                                                >
                                                    <FaEdit />
                                                </Button>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => handleDelete(plano.id)}
                                                >
                                                    <FaTrash />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            )}

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Body>
                    <PlanoForm
                        plano={currentPlano}
                        onSave={handleSave}
                        onCancel={() => setShowModal(false)}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    );
}

function PlanoForm({ plano, onSave, onCancel }) {
    const [formData, setFormData] = useState({
        id: plano?.id || null,
        nome: plano?.nome || '',
        duracao: plano?.duracao || '',
        unidade: plano?.unidade || 'dias',
        valor: plano?.valor || ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <Card className="mb-4 shadow-sm">
            <Card.Header as="h5">{plano ? 'Editar Plano' : 'Novo Plano'}</Card.Header>
            <Card.Body>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Nome do Plano</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="nome"
                                    value={formData.nome}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Duração</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="duracao"
                                    value={formData.duracao}
                                    onChange={handleChange}
                                    required
                                    min={1}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Unidade</Form.Label>
                                <Form.Select
                                    name="unidade"
                                    value={formData.unidade}
                                    onChange={handleChange}
                                >
                                    <option value="dias">Dias</option>
                                    <option value="meses">Meses</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Valor (R$)</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="valor"
                                    value={formData.valor}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={onCancel} className="me-2">
                            <FaTimes className="me-1" /> Cancelar
                        </Button>
                        <Button variant="success" type="submit">
                            <FaSave className="me-2" /> Salvar
                        </Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
}
